<template>
  <v-app id="app" :class="{'collapsed': collapsed && isAuth && !isHidden && !$vuetify.breakpoint.xsOnly,
  'not-collapsed': !collapsed && isAuth && !isHidden && !$vuetify.breakpoint.xsOnly}">
    <app-header @toolbarSideIconClick="handleToolbarSideIconClick"></app-header>
    <side-nav v-if="isAuth && !isHidden" :collapsed="collapsed" menuWidth="260" @onCollapseClick="handleCollapse"></side-nav>
    <router-view></router-view>
  </v-app>
</template>

<script>

import Header from '@/components/header/Header'
import securityStore from '@/store/security-store'
import sidebarStore from '@/store/sidebar'
import { EventBus } from '@/router/bus'
import SideNav from '@/components/side-nav/SideNav'

export default {
  components: {
    'app-header': Header,
    'side-nav': SideNav
  },
  data () {
    return {
      collapsed: sidebarStore.getters.collapsed,
      showOnXs: false
    }
  },
  methods: {
    handleCollapse (collapsed) {
      if (this.$vuetify.breakpoint.xsOnly) {
        this.showOnXs = false
      } else {
        EventBus.$emit('layout_reflow')
        this.collapsed = collapsed
        sidebarStore.dispatch('collapsed', this.collapsed)
      }
    },
    handleToolbarSideIconClick () {
      this.showOnXs = !this.showOnXs
    }
  },
  computed: {
    isAuth () {
      return securityStore.getters.isAuth
    },
    isHidden () {
      return this.$vuetify.breakpoint.xsOnly && !this.showOnXs
    }
  },
  watch: {
    '$vuetify.breakpoint.xs': function (value) {
      if (value) {
        this.showOnXs = false
      }
    }
  }
}
</script>

<style lang="scss">
#app {
  // font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

html { overflow-y: auto !important;}
.disable-events {
  pointer-events: none
}

.v-label {
  font-size: 15px !important;
}
.v-input__slot {
  margin-bottom: 0px !important;
}

.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}

.collapsed main {
  margin-left: 50px !important;
}

.not-collapsed main {
  margin-left: 260px !important;
}

.generic-link {
  cursor: pointer;
  font-weight: 700;
}

.v-sidebar-menu .vsm--title {
  white-space: normal !important;
  padding-left: 34px;
}
//Tabulator scss
.tabulator .tabulator-header .tabulator-col .tabulator-col-content .tabulator-col-title{
  white-space: normal !important;
  text-overflow: unset !important;
}
.tabulator {
  .total-elements {
    position: absolute;
    left: 0;
    font-weight: 500;
    color: #4db6ac;
  }
  .v-text-field__prefix {
    padding-right: 6px;
  }
  .v-text-field .v-input__append-inner {
    padding-left: 0;
    .v-input__icon {
      width: 18px;
      min-width: 18px;
    }
  }
}
.v-stepper{
    box-shadow: none !important;
}
.tabulator .v-icon {
  font-size: 16px;
}
.tabulator-col-content {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: 100%;
  .tabulator-col-title {
    justify-content: normal;
  }
}
.tabulator .tabulator-footer .tabulator-page:not(.disabled):hover{
  color: #4db6ac !important;
}
.tabulator .tabulator-footer .tabulator-page:not(.disabled){
  color: #4db6ac !important;
}
.tabulator .tabulator-footer .tabulator-page.active {
  color: white !important;
  border-color: #4db6ac !important;
  background-color: #4db6ac !important;
}
select.tabulator-page-size {
    // #4db6ac
    font-size: 14px;
    font-weight: normal;
    color: #6c757d;
    display: inline-block;
    border: 1px solid #dee2e6;;
    border-radius: 4px;
    padding: 8px 12px;
    margin: 5px 10px 0 5px;
    -webkit-appearance: none;
    background-position: right 15px top 22px;
    background-size: 18px 18px;
}
select.tabulator-page-size:active {
    border: 1px solid #000;
}
.tabulator label {
  font-weight: normal;
}
.tabulator-col-title {
  font-size: 15px;
  font-weight: 600;
}
@media #{map-get($display-breakpoints, 'xs-only')} {
.tabulator-paginator {
  display: flex;
  flex-flow: row wrap;
  align-items: flex-end;
  justify-content: flex-start;
  }
  .tabulator-page {
    border: 1px solid !important;
  }
  .tabulator-paginator label {
    flex-basis: 65%;
    order:1;
  }
  .tabulator-page-size{
    order:1;
  }
  [data-page="first"], [data-page="last"]{
    flex-basis: 50%;
    order:4;
  }
  .tabulator-pages {
    flex-basis: 100%;
    order:2;
    text-align: center;
  }
  [data-page="prev"], [data-page="next"]{
    flex-basis: 50%;
    order:3;
  }
}
.v-card__text, .v-card__title {
  word-break: normal !important;
}
.required label::after,h3::after{
    content: "*";
}
.btn-primary-color.v-btn{
  background-color: $button-primary-color !important;
  // min-width: 140px !important;
}

.details-label {
  font-size: 16px;
  color: rgb(112,112,112);
}

.details-label-dark {
  font-size: 16px;
  color: rgb(250, 250, 250);
}

.tiny-label-dark {
  font-size: 12px;
  color: rgb(250, 250, 250);
}

.details-label-link {
  font-size: 15px;
  color: #3F51B5;
  text-decoration: none;
}

.details-label-caption {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 5px !important;
  word-break: normal;
  overflow-wrap: break-word;
  color:#000;
}

.subheading-label {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 5px;
}

.status-pending-span {
   background-color: #CFD8DC;
   color: #000;
   border-radius: 2px;
   padding: 8px 24px;
   font-size: 12px;
 }

.status-active-span {
   background-color: #52c0a8;
   color: #fff;
   border-radius: 2px;
   padding: 8px 24px;
   font-size: 12px;
 }

.status-completed-span {
   background-color: #3d92b6;
   color: #fff;
   border-radius: 2px;
   padding: 8px 24px;
   font-size: 12px;
 }

.status-rejected-span {
   background-color: #FF5722;
   color: #fff;
   border-radius: 2px;
   padding: 8px 24px;
   font-size: 12px;
 }

 .status-error-span {
   background-color: #d3454a;
   color: #fff;
   border-radius: 2px;
   padding: 8px 24px;
   font-size: 12px;
 }

//change background color and bottom border of disabled v-text-field
.theme--light.v-input.v-input--is-disabled input {
    background-color: #e9ecef;
}
.theme--light.v-input.v-input--is-disabled label {
    margin-left: 4px;
}
.theme--light.v-text-field.v-input--is-disabled .v-input__slot:before {
  border-image: none!important;
}

.v-date-picker-table .v-btn {
  font-size: 14px !important;
}

</style>
